module.exports = __webpack_public_path__ + "d94e20c1/img/dollar-icon.35c9d638.svg";